var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-title"},[_vm._v("Edit Account")]),_c('div',{staticClass:"page-box"},[_c('userAccountSettingFrom',{ref:"ruleForm",attrs:{"ruleForm":_vm.ruleForm}}),_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.onSubmit}},[_vm._v(" Submit ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }